import { useCallback, useEffect, useState } from "react";
import { markInstallComplete } from "../lib/installPromptStorage";

let deferredPrompt = null;
/** @type {Set<() => void>} */
const listeners = new Set();

function notifyInstallPromptListeners() {
  listeners.forEach((fn) => fn());
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event;
    notifyInstallPromptListeners();
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    markInstallComplete();
    notifyInstallPromptListeners();
  });
}

export function useInstallPrompt() {
  const [canNativeInstall, setCanNativeInstall] = useState(() => Boolean(deferredPrompt));

  useEffect(() => {
    const sync = () => setCanNativeInstall(Boolean(deferredPrompt));
    listeners.add(sync);
    sync();
    return () => {
      listeners.delete(sync);
    };
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferredPrompt) return { outcome: "unavailable" };
    const prompt = deferredPrompt;
    deferredPrompt = null;
    setCanNativeInstall(false);
    notifyInstallPromptListeners();
    await prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") {
      markInstallComplete();
    }
    return { outcome };
  }, []);

  return { canNativeInstall, promptInstall };
}

export const INSTALL_PROMPT_OPEN_EVENT = "albis-open-install-prompt";

export function openInstallPrompt() {
  window.dispatchEvent(new Event(INSTALL_PROMPT_OPEN_EVENT));
}
